<template>
  <ItemPage
    title="Volumes"
    size="md"
    :actions="actions"
  >
    <template
      v-if="volumesView"
    >
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Pesquise pelo nome ou abreviatura"
        single-line
        hide-details
      />
      <v-simple-table fixed-header>
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
          class="mr-5 ml-5"
        >
          <v-data-table
            :headers="headers"
            :items="contents"
            :items-per-page="15"
            :search="search"
            item-key="id"
            @click:row="editVolume($event)"
          />
        </div>
      </v-simple-table>
    </template>
    <template v-else>
      usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import GenericFormDialog from '@/components/settings/GenericFormDialog.vue'
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      volumesView: false,
      volumesCreate: false,
      loading: false,
      loadingMsg: '',
      request: false,
      renderComponent: 0,
      contents: [],
      snackbar: false,
      msgSnackbar: '',
      timeout: 3000,
      search: '',
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'short_name'
        }
      ]
    }
  },
  computed: {
    actions () {
      return [
        {
          label: 'Adicionar volume',
          action: this.openGenericFormDialog,
          icon: 'mdi-plus',
          disabled: !this.volumesCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    fetchAll () {
      this.listVolumess()
      this.volumesView = utils.checkPermissions('volumes.view-any')
      this.volumesCreate = utils.checkPermissions('volumes.create')
    },
    async listVolumess () {
      this.loading = true
      this.loadingMsg = 'Carregando Lista...'
      try {
        this.contents = await this.$api.listVolumes()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível listar volumes, tente novamente mais tarde.', color: 'red' })
      }
      this.loading = false
    },
    editVolume (event) {
      this.$router.push({ name: 'volumes.id', params: { id: event.id } })
    },
    openGenericFormDialog () {
      this.$dialog.custom(GenericFormDialog).with({ title: 'Volumes' }).show()
        .then((volume) => {
          if (!volume) {
            return
          }
          this.newVolumes(volume)
        })
    },
    async newVolumes (data) {
      this.loadingMsg = 'Salvando...'
      try {
        await this.$api.newVolumes(data)
        this.$store.dispatch('setSnackBar', { text: 'Salvo com sucesso.' })
        this.fetchAll()
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Não foi possível salvar, tente novamente mais tarde.', color: 'red' })
      }
      this.request = false
    }
  }
}
</script>
